import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtilsV2 } from '@shared/utils';
import { CardsApi, RequestStrategyEnum, WithSignal, type CardResponse, type CardsRequest } from '@shared/api';

const getUserCardsEffect = createEffect(({ signal, ...request }: WithSignal<CardsRequest> = {}) => CardsApi.getCards(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<CardResponse[]>([])
  .on(getUserCardsEffect.done, (current, data) => data.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getUserCardsEffect.pending, (_, data) => data)
  .on(getUserCardsEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getUserCardsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getUserCardsEffect, () => null)
  // .on(getUserCardsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getUserCardsEffect.fail, (_, data) =>
    ApiUtilsV2.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Cards. Please try again.'),
  )
  .on(getUserCardsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

const getUserCardsApi = ApiUtilsV2.wrapperApi(getUserCardsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getUserCardsApi.cancel());

export const $cardsListStore = {
  events: {
    getUserCards: getUserCardsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
